import $        from "jquery";
import Viewport from './components/Viewport';
import Auth     from "./components/Auth";

'use strict';

export class Roofdesigner {

	constructor() {
		console.log('%c ROOFDESIGNER | FLETCHER STEEL LTD\n', 'background: #222; color: #bada55');
		console.log('%c by INTERACTIVESITES NEW ZEALAND @interactivesites.co.nz', 'background: #222; color: #bada55');
		// URI = use a full qualified URL when  we are offline [!] [ not necessary since v0.0.3 ]
		this.BASEURI = (location.protocol === 'file:') ? location.origin + '/' + location.pathname.replace(/index\.html/g, '') + '/cs/' : location.origin + '/' + location.pathname + '/cs/';
		// URI (will be made relative on export)
		// $cs_path = array( 'template_url' => get_bloginfo('template_url'), 'template_path' => get_template_directory() );
		this.URI = cs_path.template_url;
		// Main viewport
		this.viewport = new Viewport(this);
		this._initUI();

		// Start after login [or auto-login]
		this.auth = new Auth();
		this.auth.on('auth.success', () => {
			// Intro Ready
			this._showStartUI();
		})

		// Single click interceptor
		$('a.btn_svg').one('click', this._hideStartUI)

	}


	/**
	 * Init First Screen
	 */
	_initUI() {
		TweenMax.set('#view_roofdesigner .anim', {alpha: 0, y: "+=40"});


		//
		// Lightbox. Currently privacy policy only
		$('[data-action=lightbox]').on('click', (e) => {
			e.preventDefault();
			e.stopImmediatePropagation();
			const $target = $(e.target),
				href = $target.attr('href');
			// For now, just show lightbox and load
			TweenMax.to('#lightbox', 0.3, {"display":"block", opacity:1, scale:1 });
			// $('#lightbox .inner').load(href + '#wrapper')

		});
		$('#lightbox').on('click', (e) => {
			TweenMax.to('#lightbox', 0.3, {"display":"none", opacity:0, scale:0 });
		});


	}

	/**
	 * Show the first screen content > simply slide in
	 */
	_showStartUI() {
		TweenMax.staggerTo('#view_roofdesigner .anim', 0.8, {delay: 0.5, y: 0, alpha: 1, ease: Power3.easeOut}, 0.1);
	}

	/**
	 * Hide the first screen, just slide out. Then ....
	 */
	_hideStartUI(e) {
		e.preventDefault();
		let self = this;
		// Animate out
		let startscreen = new TimelineMax()
		.staggerTo('#view_roofdesigner .anim', 0.8, {y: '-=200', alpha: 0, ease: Power3.easeIn}, 0.1)
		.call(() => {
			window.location = $(e.currentTarget).attr('href');
		})
	}


}


(function ($) {
	$(function () {
		let intro = new Roofdesigner();
	});
})($);
